import { css } from '@emotion/css';
import { appColors, breakpoints } from '../variables.style';

export const select = css`
  .select__control {
    border-color: ${appColors.gray800};
    color: ${appColors.gray800};
    border-width: 2px;
    font-size: 20px;
    text-align: left;
    padding-left: 25px;
    border-radius: 8px;
    &:hover {
      border-color: ${appColors.orange};
    }
    @media (min-width: ${breakpoints.lg.up}) {
      font-size: 24px;
    }
  }

  .select__input {
    height: 71px;
  }

  .select__control--is-focused {
    border-color: ${appColors.orange};
    box-shadow: 0 0 0 1px ${appColors.orange};
  }

  .select__option--is-selected {
    background-color: ${appColors.orange};
  }
`;

export const selectMedium = css`
  ${select}

  .select__control {
    font-size: 16px;
    border-width: 1px;
    padding-left: 10px;
    border-radius: 4px;
  }

  .select__input {
    height: 36px !important;
  }
`;
